import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { ShieldCheck, FileText } from "@phosphor-icons/react";

export function LegalModal({ type, open, onOpenChange }) {
  const isPrivacy = type === "privacy";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] flex flex-col p-0 gap-0 overflow-hidden bg-white">
        <DialogHeader className="px-6 py-4 border-b border-slate-200 bg-slate-50/50 flex flex-row items-center gap-3 space-y-0 text-left">
          <div className="p-2 rounded-lg bg-slate-100 text-slate-700 shrink-0">
            {isPrivacy ? <ShieldCheck size={22} weight="duotone" /> : <FileText size={22} weight="duotone" />}
          </div>
          <div>
            <DialogTitle className="text-lg font-bold text-slate-900">
              {isPrivacy ? "Política de Privacidad" : "Términos y Condiciones"}
            </DialogTitle>
            <DialogDescription className="text-xs text-slate-500">
              {isPrivacy ? "Facturapp by COCO&CO · Última actualización: 9/15/2026" : "Facturapp · Términos de Servicio · Última actualización: 9/15/2026"}
            </DialogDescription>
          </div>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto p-6 text-sm text-slate-600 leading-relaxed space-y-6">
          {isPrivacy ? (
            <>
              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">1. Introduction</h3>
                <p>
                  At COCO&CO, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our application.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">2. Information We Collect</h3>
                <p>
                  We collect information that you explicitly provide to us (such as your name and email address when you sign up) and information that is automatically collected when you use our services (such as usage data and cookies).
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">3. How We Use Your Information</h3>
                <p>We use the collected information to:</p>
                <ul className="list-disc list-inside space-y-1 pl-1 text-slate-600">
                  <li>Provide and maintain our services</li>
                  <li>Notify you about changes to our services</li>
                  <li>Provide customer support</li>
                  <li>Monitor the usage of our services</li>
                  <li>Detect, prevent, and address technical issues</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">4. Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:{" "}
                  <a href="mailto:webmaster@cocoand.com" className="text-indigo-600 hover:underline font-medium">
                    webmaster@cocoand.com
                  </a>
                </p>
                <p className="text-xs text-slate-400 pt-2">Last updated: 9/15/2026</p>
              </section>
            </>
          ) : (
            <>
              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">1. Agreement to Terms</h3>
                <p>
                  By accessing or using Facturapp, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">2. Use License</h3>
                <p>
                  Permission is granted to temporarily download one copy of the materials (information or software) on Facturapp's website for personal, non-commercial transitory viewing only.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">3. Disclaimer</h3>
                <p>
                  The materials on Facturapp's website are provided on an 'as is' basis. Facturapp makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">4. Limitations</h3>
                <p>
                  In no event shall Tavola or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Tavola's website.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-slate-900 text-base">5. Contact</h3>
                <p>
                  Questions about the Terms of Service should be sent to us at:{" "}
                  <a href="mailto:legal@cocoand.com" className="text-indigo-600 hover:underline font-medium">
                    legal@cocoand.com
                  </a>
                </p>
                <p className="text-xs text-slate-400 pt-2">Last updated: 9/15/2026</p>
              </section>
            </>
          )}
        </div>

        <div className="px-6 py-3 border-t border-slate-100 bg-slate-50 flex justify-end">
          <button
            onClick={() => onOpenChange(false)}
            className="px-4 py-1.5 text-xs font-medium text-slate-700 bg-white border border-slate-200 hover:bg-slate-100 rounded-md shadow-sm transition-colors"
          >
            Cerrar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
